import styled from "styled-components";

export const PageTitleWrap = styled.div`
  margin-bottom: 2.4rem;
  p {
    font-weight: 400;
  }
`;
